import { jsx as _jsx } from "react/jsx-runtime";
import { useMounted } from 'shared/hooks/utils';
import { useEffect, useMemo } from 'react';
import { debounce } from 'throttle-debounce';
import { TabSkeleton } from './index';
import { useBooleanState } from 'shared/hooks/state/boolean';
export function useSkeleton(tab_key, active = true, timeout = 0) {
    // это кэш размером 1 для каждой вкладки
    const [isVisible, , setIsVisible] = useBooleanState(false);
    const isMounted = useMounted();
    useEffect(() => {
        if (isMounted.current) {
            if (active) {
                if (timeout) {
                    debounce(timeout, setImmediate)(setIsVisible);
                }
                else {
                    setImmediate(setIsVisible);
                }
            }
        }
    }, [active]);
    const Skeleton = useMemo(() => {
        const SkeletonComponent = ({ children, active = true, }) => {
            return (_jsx(TabSkeleton, { is_loaded: isVisible && active, tabKey: tab_key, children: active || isVisible ? children : null }));
        };
        return SkeletonComponent;
    }, [tab_key, isVisible]);
    return Skeleton;
}
